/**
 * For solicitor portal dashboard mainly
 */
(()=>{
    // function to toggle 'active' class
    // the toggle button should either have 'toggle-sidebar' as class or as id
    const toggleActiveClassFunction = () => {
        // sidebar and main div
        const sidebar = document.querySelector( '#nav-sidebar' ),
        mainDivs = document.querySelectorAll('.main-content');

        // if have 'active' class then remove
        if( sidebar.classList.contains("active") ){
            sidebar.classList.remove("active");
            mainDivs.forEach(_div => _div.classList.remove( "active" ));
            document.querySelector('.account-info').style.visibility= 'hidden';
        }
        // else add 'active' class
        else{
            sidebar.classList.add("active");
            mainDivs.forEach(_div => _div.classList.add( "active" ));
            document.querySelector('.account-info').style.visibility= 'visible';
        }
    };
    window.addEventListener("load", () => {
        const hamBtn = document.getElementById("toggle-sidebar");
        if( hamBtn ) hamBtn.addEventListener('click', toggleActiveClassFunction);

        const hamBtns = document.querySelectorAll(".toggle-sidebar");
        if( hamBtns.length > 0 ) hamBtns.forEach( _hamBtn => _hamBtn.addEventListener('click', toggleActiveClassFunction));
    });
    
})();